export default "__VITE_ASSET__Bwetq_4h__"